import { render, staticRenderFns } from "./PositionSelector.vue?vue&type=template&id=c9d1e258&scoped=true&"
import script from "./PositionSelector.vue?vue&type=script&lang=js&"
export * from "./PositionSelector.vue?vue&type=script&lang=js&"
import style0 from "./PositionSelector.vue?vue&type=style&index=0&id=c9d1e258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d1e258",
  null
  
)

export default component.exports